// import getCompanyData from '@/utils/companyData.js'
/**
 * 该文件内为系统信息
 */

// 网络请求超时时间(单位：毫秒)
export const httpTimeout = 15000;

// 加密、解密的密码(再加密处理)20BAD6697AD42FB035B7593BE80E4FEF
export const AESPassword =
  "7qYKqpHIXXXZAk2lIpi7VbvpFy0bE6Tl2+tTOutLRzRve/z4R3yQMa9P2OewUEaO";

// cookie过期时间（单位：分钟）
export const cookieOutTime = 120;

// token过期时间(单位：分钟)
export const tokenOutTime = 120;

// 短信验证过期时间(单位：秒)
export const SMSOutTime = 60;

// 百度地图开发者AK密钥 （未加密）
export const baiduAK = "wtAToNKnwRKcVN8X7n9SEn3tEIKKDmYW";

let href = window.location.href;
let h = href.split(".")[0];
let code = h.split("//")[1];

// export const companyData = getCompanyData(code)

// -- 正式服务器
// 服务器地址
// export const serverIpAddress = `http://${companyData.code == 'zb'?'www':companyData.code}.yangziclean.com/prod-api`
// export const serverIpAddress = `http://106.14.35.51:8090/prod-api`
export const serverIpAddress = `http://www.eppinno.com/prod-api`;
// export const serverIpAddress = `https://web.lationyun.com/prod-api`;
// export const serverIpAddress = `http://172.16.20.142:8085`
// 后台管理服务器地址 stock-management
export const serverIpAddress_ht = `http://manage.eppinno.com/prod-api`;
// export const serverIpAddress_ht = `https://web.lationyun.com/prod-api`;
// 测试服务器
// export const serverIpAddress = `http://test.yangziclean.com/prod-api`
// export const serverIpAddress = `http://106.14.35.51:9010/prod-api`;
// export const serverIpAddress_ht = `http://172.16.20.142:8085`
// 后台管理测试服务器
// export const serverIpAddress_ht = `http://172.16.20.37:8085`
// 公众号ID
export const weChatAppId = "wxf357e7683b7e3c4b"; // wx04077839db7fcb48
// 商品图片服务器地址(正式)
export const imgServerIp = "";
export const userImgAddress = "";

// -- 测试服务器
// 服务器地址
// export const serverIpAddress = 'http://172.16.20.16:8082'
// // 公众号ID
// export const weChatAppId = 'wx17dfd3efb39c2d50'
// // // 图片服务器地址(测试) 商品图片
// export const imgServerIp = ''
// export const userImgAddress = 'http://172.16.20.16:8082/prod-api'

// -- 本地服务器
// // 服务器地址
// export const serverIpAddress = 'http://192.168.11.111:9897'
// // export const serverIpAddress = 'http://192.168.11.111:9897'
// // 公众号ID
// export const weChatAppId = 'wx17dfd3efb39c2d50'
// // 图片服务器地址(测试)
// export const imgServerIp = 'http://192.168.11.102:9002'
// export const userImgAddress = 'http://192.168.11.102:9002/prod-api'



// WEBPACK FOOTER //
// ./src/util/systemConfig.js